import { grey } from "@mui/material/colors";
import { jsx as _jsx } from "react/jsx-runtime";
export function RowNumberIndicator(props) { return /*#__PURE__*/ _jsx("div", { style: { paddingRight: 4, color: grey["600"] }, children: props.value }); }
